import styled from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';
import { gap } from '../../../../juristec-ui/styles/theme';

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MessageRow = styled(Row)`
  margin: 0 .5rem 1rem;
  ${gap('5px', 'row')};
  min-width: 310px;
  @media ${devices.phoneS} {
    min-width: auto;
  }
`;

export const MessageColumn = styled(Column)`
  margin: 0 .5rem 1rem;
  ${gap('5px', 'column')};
  min-width: 310px;
  @media ${devices.phoneS} {
    min-width: auto;
  }
  & span {
    display: inline-block;
  };
`;

export const ItemContainer = styled(Row)`
  width: 100;
`;
